import { inject } from '@angular/core'
import { CanDeactivateFn } from '@angular/router'
import { UnsavedChangesService } from '../services/unsaved-changes.service'

export const unsavedChangesGuard: CanDeactivateFn<unknown> = () => {
  const service = inject(UnsavedChangesService)

  if (service.hasUnsavedChanges()) {
    service.shakeBar()
    return false
  }

  return true
}
